const translations = {
  fr: {
    tutorials: {
      tutorialPageTitle: 'Tutoriels',
      introduction: {
        title: 'Introduction',
        platform: 'Plateforme',
        userAccessVideo: 'Accès utilisateur (Vidéo)',
        userAccess: 'Accès utilisateur (Texte)',
      },
      programming: {
        title: 'Espace Programmation',
        dashboardVideo: 'Tableau de bord (Vidéo)',
        dashboard: 'Tableau de bord (Texte)',
        history: 'Historique',
        reach: 'Portée',
        listeningTime: 'Temps d\'écoute',
        demography: 'Démographie',
      },
      video: {
        userAccess: 'XnUtrDElAso',
        dashboard: '0mjR3Iulgj0',
      },
      sales: {
        title: 'Espace Ventes',
        terms: 'Termes publicitaires',
        summary: 'Sommaire',
        estimation: 'Estimation',
      },
      follo: {
        title: 'Follo',
        titleAdvertiser: 'Follo Annonceur',
        salesEstimation: 'Estimation de vente',
        createProposition: 'Création d\'une proposition',
        customersManage: 'Gestion de clients',
        campaignCreation: 'Créer une campagne',
        addSpots: 'Ajout de spots',
        addTimes: 'Ajout des heures de diffusions d\'une campagne',
        campaignsStatistics: 'Accéder à la performance d\'une campagne',
        finishCampaign: 'Terminer une campagne',
        advertiser: 'Annonceur',
        platform: 'Plateforme',
      },
      other: 'Autre',
      theGuide: 'Le Guide',
    },
  },
  en: {
    tutorials: {
      tutorialPageTitle: 'Tutorials',
      introduction: {
        title: 'Introduction',
        platform: 'Platform',
        userAccessVideo: 'User access (Video)',
        userAccess: 'User access (Text)',
      },
      programming: {
        title: 'Programming Module',
        dashboardVideo: 'Dashboard (Video)',
        dashboard: 'Dashboard (Text)',
        history: 'History',
        reach: 'Reach',
        listeningTime: 'Listening Time',
        demography: 'Demography',
      },
      video: {
        userAccess: 'XnUtrDElAso',
        dashboard: '3zCe_rqo-NQ',
      },
      sales: {
        title: 'Sales Module',
        terms: 'Advertising terms',
        summary: 'Summary',
        estimation: 'Estimation',
      },
      follo: {
        title: 'Follo',
        titleAdvertiser: 'Follo Advertiser',
        salesEstimation: 'Sales Estimation',
        createProposition: 'Create Proposal',
        customersManage: 'Customers Management',
        campaignCreation: 'Create a campaign',
        addSpots: 'Add Spots',
        addTimes: 'Adding broadcast times to a campaign',
        campaignsStatistics: 'Access campaign performance',
        finishCampaign: 'Complete a campaign',
        advertiser: 'Advertiser',
        platform: 'Platform',
      },
      other: 'Other',
      theGuide: 'The Guide',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/tutorials/i18n/tutorials.js